import Vue from 'vue'
import Router from 'vue-router'
//import Login from '.././views/login.vue'
//import NotFound from '.././views/404.vue'
//import Home from '.././views/index.vue'
Vue.use(Router)

export default new Router({
  mode: 'history',//去掉#号
  routes: [
    {
      path: '/',
      name: 'index',
      component: resolve => require(['../view/index.vue'],resolve)
    },
	{
	  path: '/index',
	  name: 'index',
	  component: resolve => require(['../view/index.vue'],resolve)
	},
	{
	  path: '/platform',
	  name: 'platform',
	  component: resolve => require(['../view/platform.vue'],resolve)
	},
	{
	  path: '/canvass',
	  name: 'canvass',
	  component: resolve => require(['../view/canvass.vue'],resolve)
	},
	{
	  path: '/about',
	  name: 'about',
	  component: resolve => require(['../view/about.vue'],resolve)
	},
	{
	  path: '/newsCenter',
	  name: 'newsCenter',
	  component: resolve => require(['../view/newsCenter.vue'],resolve)
	},
	{
	  path: '/newsDetail',
	  name: 'newsDetail',
	  component: resolve => require(['../view/newsDetail.vue'],resolve)
	},
	{
	  path: '/recruit',
	  name: 'recruit',
	  component: resolve => require(['../view/recruit.vue'],resolve)
	},
	{
	  path: '/downLoad',
	  name: 'downLoad',
	  component: resolve => require(['../view/downLoad.vue'],resolve)
	},
	{
	  path: '/index_mobile',
	  name: 'indexM',
	  component: resolve => require(['../view/index_mobile.vue'],resolve)
	},
	],
})